var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main__top"},[_vm._t("header")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }